import { LinearProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface LinearUsageProps {
  used: number;
  total: number;
}

export function LinearUsage({ used, total }: LinearUsageProps) {
  const { t } = useTranslation();

  const value = total > 0 ? Math.min((used / total) * 100, 100) : 0;
  const remaining = Math.max(total - used, 0);

  return (
    <Stack direction="column" spacing={1} alignItems="center" width="100%">
      <LinearProgress variant="determinate" value={value} />
      <Stack direction="row" spacing={1} justifyContent="space-between" width="100%">
        <Typography variant="caption">{t('Used: {{used}}', { used })}</Typography>
        <Typography variant="caption">{t('Remaining: {{remaining}}', { remaining })}</Typography>
      </Stack>
    </Stack>
  );
}
